import { render, staticRenderFns } from "./BannerTwoColumn.vue?vue&type=template&id=18972278&"
import script from "./BannerTwoColumn.vue?vue&type=script&lang=js&"
export * from "./BannerTwoColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports